define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var i18n = require('i18n');
    var $ = require('j');
    var core = require('core');
    var historyUtil = require('util/history.util');
    var device = require('util/device.util');
    var urlUtil = require('util/url.util');
    var server = require('server');
    var CashierUtil = require('modules/cashier/cashier.util');
    var storage = require('util/storage.util');

    module.exports = _.extend(CashierUtil, {

        notifyTransactionStatus: function(href) {
            var deferred = $.Deferred();
            var urlParams = urlUtil.getURLParams(href);
            const googlePaySuccess = storage.session.getItem('GooglePaySuccess');

            if (urlParams.initiator !== 'cashier_backbone') {
                !googlePaySuccess && deferred.resolve();
            }

            var redirectType = urlParams.redirectType;
            var originalStatus = urlParams.status;
            var status = originalStatus === 'success' ? 'success' : googlePaySuccess ? 'success' : 'error';
            var action = urlParams.action;
            var data = urlParams.extraData;
            var transactionCode = urlParams.transactionCode || '';
            var title = action ? i18n.t('playtech.mobile.system.mobile-cashier.' + action + '.title') : '';
            var clientType = urlParams.clientType || urlParams.clienttype;
            var resultUrl = clientType
                ? `${urlUtil.pathname}?clientType=${clientType}${urlUtil.hash}`
                : `${urlUtil.pathname}${urlUtil.hash}`;
            var result = {
                status: status,
                action: action,
                title: title,
                data: data || storage.session.getItem('deposit_action')
            };
            var eventName;

            this.addToEventsQueue(`${action}:${status}`, result.data);
            googlePaySuccess && core.trigger('deposit:success', result.data);
            storage.session.removeItem('GooglePaySuccess');

            this.promoCode.handleTransactionResult(result);

            this._handleIosSafariScalingBug();

            if (_.contains(['success', 'error', 'cancel', 'waiting'], originalStatus)) {

                window.Playtech.API.common.navigate(resultUrl, {
                    ...historyUtil.state,
                    replace: true
                }, { preserveSearchParams: false });

                /**
                 * Possible values:
                 * 'deposit:success', 'deposit:fail', 'withdraw:success', 'withdraw:fail'
                 * @type {string}
                 */
                eventName = action + ':' + (status === 'success' ? 'success' : 'fail');

                core.trigger(eventName, urlParams);

                if (status === 'error') {
                    // will show popup on DC side
                    if (device && device?.isDownloadClient()) {
                        return deferred.resolve();
                    }

                    this.showNotifyTransactionStatusPopup(result);

                    return deferred.resolve();
                }

                if (redirectType) {
                    return deferred.resolve();
                }

                if (transactionCode.length) {
                    return server.send({
                        ID: 35640,
                        description: 'Get Transaction Player Message',
                        transactionId: transactionCode,
                        type: action,
                        responses: [35641, 35645]
                    })
                        .done(function(response) {
                            _.map(response.data.actions, function(responseAction) {
                                this.showNotifyTransactionStatusPopup(result,
                                    responseAction.showMessageNotificationInfo.message);
                            }.bind(this));
                        }.bind(this))
                        .fail(function(response) {
                            this.showNotifyTransactionStatusPopup(result, response.data.errorMessage);
                        }.bind(this));
                }

                return deferred.resolve();
            }

            return deferred.resolve();
        },

        showNotifyTransactionStatusPopup: function(result, content) {
            window.Playtech.API.popup.showPopup({
                title: result.title,
                content: content || i18n.t('playtech.mobile.system.mobile-cashier.transaction.' + result.status),
                onClose: this.onCloseNotifyTransactionStatusPopup.bind(this, result)
            });
        },

        addToEventsQueue: function(event, data) {
            const events = storage.session.getItem('core_events') || {};

            events[event] = events[event] || data;
            storage.session.setItem('core_events', events);
        }
    });
});
